<form #sipReasonGroupDialog="ngForm" autocomplete="off">
  <mat-form-field class="fullWidth">
    <mat-label>Name</mat-label>
    <input matInput required [(ngModel)]="sipReasonGroup.name" maxlength="255" name="name">
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Description</mat-label>
    <input matInput [(ngModel)]="sipReasonGroup.description" maxlength="255" name="name">
  </mat-form-field>
</form>

